export default __webpack_public_path__ + "static/media/average.31b4c741.png";